import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { CSSProperties } from "react"
import { Color } from "../../constants"
import { AntdIconWrap } from "../uiKit/Icons/AntdIconWrap"

export const ImagePreviewComponent = ({
    logo,
    alt,
    squareSize,
    style = {},
    onRemove,
}: {
    logo: string
    alt: string
    squareSize?: Maybe<number>
    style?: Record<string, any>
    onRemove: () => void
}) => {
    return (
        <div
            style={{
                ...styles.imagePreviewContainer,
                ...(squareSize
                    ? {
                          width: squareSize + "px",
                          height: squareSize + "px",
                          padding: "6px",
                          display: "inline-flex",
                      }
                    : {}),
                ...style,
            }}>
            <a href={logo} target="_blank" rel="noopener noreferrer">
                <img alt={alt} src={logo} style={styles.previewImg} />
            </a>
            <div
                style={{
                    ...styles.removeImage,
                    ...(squareSize
                        ? {
                              fontSize: "15px",
                              right: "6px",
                              bottom: "-6px",
                          }
                        : {}),
                }}
                role="button"
                tabIndex={0}
                onKeyPress={() => onRemove()}
                onClick={() => onRemove()}>
                <AntdIconWrap type="delete" />
                {!squareSize && <span> Remove</span>}
            </div>
        </div>
    )
}
const styles: Record<string, CSSProperties> = {
    imagePreviewContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        borderRadius: "6px",
        border: "1px dashed #CCC",
        textAlign: "center",
        padding: "12px",
    },
    previewImg: {
        maxWidth: "100%",
        maxHeight: "100px",
    },
    removeImage: {
        position: "absolute",
        right: "12px",
        bottom: "-5px",
        background: "white",
        fontSize: "13px",
        color: Color.Red,
        cursor: "pointer",
        padding: "0 4px",
        lineHeight: 1,
    },
}
